(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["centered-image-v3"] && !window.DesignMode) return;
  try {
    
  $( document ).ready(function () {
    function craftLines () {
      if ($(window).width() > 768) {
        for (let i = 0; i < $('.centered-image-v3 .left .row').length; i++) {
          var leftRow = $('.centered-image-v3 .left .row')[i],
              rightRow = $('.centered-image-v3 .right .row')[i],
              line = $('.centered-image-v3 .image .line')[i],
              lineStartEl = $(rightRow).find('.outer-dot'),
              lineOffset = 0;
        
          if ($(leftRow).outerHeight() >= $(rightRow).outerHeight()) {
              $(rightRow).outerHeight($(leftRow).outerHeight());
          } else {
              $(leftRow).outerHeight($(rightRow).outerHeight());
          }
            
          lineOffset = $(lineStartEl).offset().top - $(rightRow).closest('.rows').offset().top;
          lineOffset += $(lineStartEl).height() / 2;
          $(line).css('top', lineOffset);
        }
      }
    }
    craftLines()
    $(window).on('resize', craftLines);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  var scrolledPastHeader = new CustomEvent("scrolledPastHeader");
  var backToHeader = new CustomEvent("backToHeader");
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.dispatchEvent(scrolledPastHeader);
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.dispatchEvent(scrolledPastHeader);
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.dispatchEvent(backToHeader);
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      try {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        this.searchModal.close(false);
      } catch (error) {}
    }
  }
    $(document).ready(function () {
     if (document.documentElement.scrollTop  > 0 || document.body.scrollTop > 0) {
       $('.shopify-section-header-sticky').addClass('scrolled-past-header');
       document.dispatchEvent(scrolledPastHeader);
     }
    })
  
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-custom-1"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.main-custom-1__slider-init').slick({
      mobileFirst: true,
      arrows: false,
      dots: true,
      appendDots: $('.main-custom-1__dots'),
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      variableWidth: true,
      responsive: [
        {
          breakpoint: 1300,
            settings: "unslick"
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.review-slider__init').slick({
      arrows: true,
      appendArrows: $('.review-slider__arrows'),
      prevArrow: '<img class="review-slider__slick-prev" src="https://cdn.shopify.com/s/files/1/0728/4971/9575/files/review-slider-arrow.png?v=1681392516" alt="arrow-previous" width="36px" height="auto">',
      nextArrow: '<img class="review-slider__slick-next" src="https://cdn.shopify.com/s/files/1/0728/4971/9575/files/review-slider-arrow.png?v=1681392516" alt="arrow-next" width="36px" height="auto">',
      dots: true,
      appendDots: $('.review-slider__dots'),
      infinite: true,
      centerMode: true,
      centerPadding: '170px',
      slidesToShow: 3,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 1,
            centerPadding: '300px',
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 1,
            centerPadding: '80px',
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slick-slider"] && !window.DesignMode) return;
  try {
    
  $(document).ready(function(){
    $('.slick-slider-init').slick({
      dots: false,
      arrows: false,
      infinite: true,
      variableWidth: true,
      swipeToSlide: true,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 768,
            settings: "unslick"
        }
      ]
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-section"] && !window.DesignMode) return;
  try {
    
  $( document ).ready(function () {
    function defineVerticalLine () {
      var verticalLine = $('.text-section .col.left .vertical-line');
      
      // Resetting the styles
      $(verticalLine).removeAttr('style');
          
      var firstRowHeight = $('.text-section .col.left .row:first').outerHeight(),
          lastRowHeight = $('.text-section .col.left .row:last').outerHeight(),
          verticalLineHeight = $(verticalLine).outerHeight(),
          verticalLineHeightOffsetTop = firstRowHeight / 2,
          newVerticalLineHeight = verticalLineHeight - (firstRowHeight + lastRowHeight) / 2;

      $(verticalLine).css({
          'top' : `${verticalLineHeightOffsetTop}px`,
          'height' : `${newVerticalLineHeight}px`
      });
    };
  
    defineVerticalLine();
    $(window).on('resize', defineVerticalLine);
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-sectionV2"] && !window.DesignMode) return;
  try {
    
  $( document ).ready(function () {
    function defineVerticalLine () {
      var verticalLine = $('.text-section .col.left .vertical-line');
      
      // Resetting the styles
      $(verticalLine).removeAttr('style');
          
      var firstRowHeight = $('.text-section .col.left .row:first').outerHeight(),
          lastRowHeight = $('.text-section .col.left .row:last').outerHeight(),
          verticalLineHeight = $(verticalLine).outerHeight(),
          verticalLineHeightOffsetTop = firstRowHeight / 2,
          newVerticalLineHeight = verticalLineHeight - (firstRowHeight + lastRowHeight) / 2;

      $(verticalLine).css({
          'top' : `${verticalLineHeightOffsetTop}px`,
          'height' : `${newVerticalLineHeight}px`
      });
    };
  
    defineVerticalLine();
    $(window).on('resize', defineVerticalLine);
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-sectionV3"] && !window.DesignMode) return;
  try {
    
  $( document ).ready(function () {
    function defineVerticalLine () {
      var verticalLine = $('.text-section .col.left .vertical-line');
      
      // Resetting the styles
      $(verticalLine).removeAttr('style');
          
      var firstRowHeight = $('.text-section .col.left .row:first').outerHeight(),
          lastRowHeight = $('.text-section .col.left .row:last').outerHeight(),
          verticalLineHeight = $(verticalLine).outerHeight(),
          verticalLineHeightOffsetTop = firstRowHeight / 2,
          newVerticalLineHeight = verticalLineHeight - (firstRowHeight + lastRowHeight) / 2;

      $(verticalLine).css({
          'top' : `${verticalLineHeightOffsetTop}px`,
          'height' : `${newVerticalLineHeight}px`
      });
    };
  
    defineVerticalLine();
    $(window).on('resize', defineVerticalLine);
  });
  

  } catch(e) { console.error(e); }
})();
})();
